import { connect } from 'react-redux';
import {
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getCurrencyCode,
  getCustomCashbackIconUrl,
  getIsHotelOnly,
  getIsWebview,
} from 'src/store/view/selectors';
import { fetchHotelImagesAction } from 'src/store/hotelImages/sagaActions';
import { hotelImagesByIdSelector } from 'src/store/hotelImages/selectors';
import HotelRenderer from './HotelRenderer';
import { getIsViewed } from '../../selectors/viewedHotels';
import {
  getRequestId,
  isFlexDatesSelector,
} from '../../selectors/searchParams';
import { getOfferFilters } from '../../selectors/filters';
import { resetPopupData } from '../../store/map/slice';
import { setActiveHotelDataAction } from '../../store/map/sagaActions';

const mapStateToProps = (state, { id, images }) => ({
  customCashbackIconURL: getCustomCashbackIconUrl(state),
  customCashbackText: getCashbackLabel(state),
  customCashbackTooltipText: getCashbackTooltip(state),
  currencyCode: getCurrencyCode(state),
  hotelPageVisited: getIsViewed(state, id),
  isFlexDates: isFlexDatesSelector(state),
  isHotelOnly: getIsHotelOnly(state),
  images: hotelImagesByIdSelector(state, id) || images,
  offerFilters: getOfferFilters(state),
  requestId: getRequestId(state),
  openInCurrentTab: getIsWebview(state),
  isCashbackEnable: getActivateCashbackForPartner(state),
});

const mapDispatchToProps = {
  getImages: fetchHotelImagesAction,
  resetPopupData,
  setActiveHotel: setActiveHotelDataAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HotelRenderer);
